import { cn } from '@/lib/utils';

const ColorNewTag = (props: { textClassName?: string; iconClassName?: string }) => {
  const { textClassName, iconClassName } = props;

  return (
    <>
      <div
        className={cn(
          'absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 font-jost text-[11px] text-white',
          textClassName,
        )}
      >
        New
      </div>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='12'
        height='9'
        fill='none'
        viewBox='0 0 12 9'
        className={cn('absolute right-[3px] top-1', iconClassName)}
      >
        <path
          fill='#fff'
          d='M0 4.023a.374.374 0 1 0 .749 0 .374.374 0 0 0-.749 0M10.317 3.284A4.51 4.51 0 0 1 7.668 0 4.51 4.51 0 0 1 5.02 3.284c-.266.116-.929.294-.929.294s.663.178.93.294a4.51 4.51 0 0 1 2.648 3.284 4.51 4.51 0 0 1 2.649-3.284c.266-.116.93-.294.93-.294s-.664-.178-.93-.294m-5.652 3.09a2.68 2.68 0 0 1-1.57-1.947 2.68 2.68 0 0 1-1.57 1.947c-.158.068-.551.174-.551.174s.393.106.55.175a2.68 2.68 0 0 1 1.57 1.946 2.68 2.68 0 0 1 1.571-1.946c.158-.07.551-.175.551-.175s-.393-.105-.55-.174m6.436.174a.374.374 0 1 1-.749 0 .374.374 0 0 1 .749 0M4.226 1.4a.374.374 0 1 1-.749 0 .374.374 0 0 1 .75 0'
        ></path>
      </svg>
    </>
  );
};

export default ColorNewTag;
